'use strict';

var Css = require("bs-css-emotion/lib/js/src/Css.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Theme$PvpcontrollerWeb = require("../Theme.js");

var prompt = Curry._1(Css.style, {
      hd: Css.position(Css.fixed),
      tl: {
        hd: Css.width({
              NAME: "percent",
              VAL: 100.0
            }),
        tl: {
          hd: Css.height({
                NAME: "percent",
                VAL: 100.0
              }),
          tl: {
            hd: Css.top("zero"),
            tl: {
              hd: Css.right("zero"),
              tl: {
                hd: Css.bottom("zero"),
                tl: {
                  hd: Css.left("zero"),
                  tl: {
                    hd: Css.background(Css.rgba(0, 0, 0, {
                              NAME: "num",
                              VAL: 0.5
                            })),
                    tl: {
                      hd: Css.display("flex"),
                      tl: {
                        hd: Css.alignItems(Css.center),
                        tl: {
                          hd: Css.flexDirection(Css.column),
                          tl: {
                            hd: Css.zIndex(1),
                            tl: /* [] */0
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    });

var panel = Curry._1(Css.style, {
      hd: Css.backgroundColor(Theme$PvpcontrollerWeb.panelColor),
      tl: {
        hd: Css.paddingLeft(Css.px(100)),
        tl: {
          hd: Css.paddingRight(Css.px(100)),
          tl: {
            hd: Css.paddingBottom(Css.px(20)),
            tl: {
              hd: Css.marginTop({
                    NAME: "percent",
                    VAL: 18.0
                  }),
              tl: /* [] */0
            }
          }
        }
      }
    });

var text = Curry._1(Css.style, {
      hd: Css.color(Theme$PvpcontrollerWeb.textColor),
      tl: {
        hd: Css.fontSize(Css.px(18)),
        tl: {
          hd: Css.marginBottom(Css.px(20)),
          tl: /* [] */0
        }
      }
    });

var button = Curry._1(Css.style, {
      hd: Css.backgroundColor(Css.hex("282b2f")),
      tl: {
        hd: Css.border(Css.px(0), Css.solid, Css.hex("000")),
        tl: {
          hd: Css.color(Css.hex("797c82")),
          tl: {
            hd: Css.fontSize(Css.px(20)),
            tl: {
              hd: Css.margin(Css.px(10)),
              tl: {
                hd: Css.padding(Css.px(10)),
                tl: {
                  hd: Css.cursor(Css.pointer),
                  tl: /* [] */0
                }
              }
            }
          }
        }
      }
    });

function Prompt(Props) {
  var title = Props.title;
  var onOkClick = Props.onOkClick;
  var children = Props.children;
  return React.createElement("div", {
              className: prompt
            }, React.createElement("div", {
                  className: panel
                }, React.createElement("h2", {
                      className: Theme$PvpcontrollerWeb.title
                    }, title), React.createElement("p", {
                      className: text
                    }, children), React.createElement("button", {
                      className: button,
                      onClick: onOkClick
                    }, "Ok")));
}

function makeProps(prim0, prim1, prim2, prim3, prim4) {
  var tmp = {
    title: prim0,
    onOkClick: prim1,
    children: prim2
  };
  if (prim3 !== undefined) {
    tmp.key = prim3;
  }
  return tmp;
}

var make = Prompt;

exports.makeProps = makeProps;
exports.make = make;
/* prompt Not a pure module */
